module.exports = __webpack_public_path__ + "img/continuar.f3431939.png";